import { Subject } from 'rxjs'

import { BaseService } from './base'

export class EventService<T> extends BaseService {
  private subject = new Subject<T>()

  get onEvent() {
    return this.subject.asObservable()
  }

  dispatch(event: T) {
    this.subject.next(event)
  }
}
